<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>Tablas</h1>
        </div>
        <br />
        @if (environment.name === 'prod') {
            <iframe
                title="tables_madeja_prod"
                width="100%"
                height="700"
                src="https://app.powerbi.com/view?r=eyJrIjoiZjU1MjYyOTgtMmE4ZC00MjFlLWEzMGUtZDI2ZGE0MzEyMmQxIiwidCI6ImVjYWZiM2EyLWE2Y2YtNDI2NC05NTVlLWUxODFiNzRjNmFhZSIsImMiOjR9"
                frameborder="0"
                allowFullScreen="true"
            ></iframe>
        }
        @else {
            <iframe
                title="tables_madeja_dev"
                width="100%"
                height="700"
                src="https://app.powerbi.com/view?r=eyJrIjoiZjU1MjYyOTgtMmE4ZC00MjFlLWEzMGUtZDI2ZGE0MzEyMmQxIiwidCI6ImVjYWZiM2EyLWE2Y2YtNDI2NC05NTVlLWUxODFiNzRjNmFhZSIsImMiOjR9"
                frameborder="0"
                allowFullScreen="true"
            ></iframe>
        }
    </div>
</div>
